import { useState } from 'react';
import { supabase } from '../../supabase';
import { useNavigate } from 'react-router-dom';
import ProjectHeader from '../../components/common/ProjectHeader/ProjectHeader';
//Hasło
import { FaRegEye } from "react-icons/fa";
import { FaRegEyeSlash } from "react-icons/fa";
import '../../styles/Login.css';

export default function Login() {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [password_second, setPassword_second] = useState('');
  const [notification, setNotification] = useState('');
  const [icon, setIcon] = useState(FaRegEyeSlash);
  const [type, setType] = useState('password');

  const handleToggle = () => {
   if (type==='password'){
      setIcon(FaRegEye);
      setType('text')
   } else {
      setIcon(FaRegEyeSlash);
      setType('password')
   }
}
  const nav = useNavigate();



  const signUp = async (e) => {
    e.preventDefault();
    if(password == password_second){
      const { error } = await supabase.auth.signUp({
        email,
        password
      });
      if(error) { alert(error.message); return; }
      alert("Konto utworzone! Zaloguj się");
      nav("/online");
    }
    else{
      setNotification("Hasła muszą być takie same");
    }

  }

  return (
    <div>
      <ProjectHeader
        headerTitle={'Logowanie'}
        showBackButton={true}
        path={"/"}
      />

      <div className="LoggingForm">
        <form>
          <input type="email" placeholder="email" onChange={e=>setEmail(e.target.value)}/> <br/>
          <div className="password-container"> 
            <input type={type} placeholder="hasło" onChange={e=>setPassword(e.target.value)}/>
            <span onClick={handleToggle}>
              <span className="toggle-icon"> 
                {icon}
              </span>
            </span>
          </div>
          <input type={type} placeholder="hasło" onChange={e=>setPassword_second(e.target.value)}/>
  
          <p style = {{color: "red"}}> {notification} </p>
          <button type="button" onClick={signUp}>Zarejestruj</button>

        </form>
      </div>
    </div>
  );
}